import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import customersReducer from './slices/customersSlice';
import leadsReducer from './slices/leadsSlice';
import templatesReducer from './slices/templatesSlice';
import promotionsReducer from './slices/promotionsSlice';
import broadcastsReducer from './slices/broadcastsSlice';
import broadcastListsReducer from './slices/broadcastListsSlice';
import messagesReducer from './slices/messagesSlice';
import phoneNumbersReducer from './slices/phoneNumbersSlice';
import phoneNumbersDynamicReducer from './slices/phoneNumbersDynamicSlice';
import webhooksReducer from './slices/webhooksSlice';
import businessAccountsReducer from './slices/businessAccountsSlice';
import mediaReducer from './slices/mediaSlice';
import wabaReducer from './slices/wabaSlice';
import conversationsReducer from './slices/conversationsSlice';
import invoicesReducer from './slices/invoicesSlice';
import catalogsReducer from './slices/catalogsSlice';
import productsReducer from './slices/productsSlice';
import businessProfilesReducer from './slices/businessProfilesSlice';
import ordersReducer from './slices/ordersSlice';
import templateSettingsReducer from './slices/templateSettingsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    customers: customersReducer,
    leads: leadsReducer,
    templates: templatesReducer,
    promotions: promotionsReducer,
    broadcasts: broadcastsReducer,
    broadcastLists: broadcastListsReducer,
    messages: messagesReducer,
    phoneNumbers: phoneNumbersReducer,
    phoneNumbersDynamic: phoneNumbersDynamicReducer,
    webhooks: webhooksReducer,
    businessAccounts: businessAccountsReducer,
    media: mediaReducer,
    waba: wabaReducer,
    conversations: conversationsReducer,
    invoices: invoicesReducer,
    catalogs: catalogsReducer,
    products: productsReducer,
    businessProfiles: businessProfilesReducer,
    orders: ordersReducer,
    templateSettings: templateSettingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Type exports for TypeScript (if converting to TS later)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

